import { memo } from "react";

import { LoadScript } from "../scripts/LoadScript";

import type { ScriptHTMLAttributes } from "react";

export interface RawHtmlProps {
  html?: string;
  scripts?: ScriptHTMLAttributes<HTMLScriptElement>[];
}

export const RawHtml = memo(function RawHtml({
  html = "",
  scripts,
}: RawHtmlProps) {
  return (
    <>
      <div
        dangerouslySetInnerHTML={{ __html: html.trim() }}
        suppressHydrationWarning
      />

      {scripts?.map((x) => (
        <LoadScript key={x.src} src={x.src} type={x.type} />
      ))}
    </>
  );
});
